import React, { useRef, useEffect } from 'react'
import { memo } from 'react'
import { Box, Slide } from '@mui/material'
import JobDetailContent from './JobDetailContent'

const JobDetailPanel = ({ rankedJob, conversationId, onFavoriteClick, onAskStethi }) => {
  const job = rankedJob?.job
  const scrollContainerRef = useRef(null)

  useEffect(() => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTop = 0
    }
  }, [rankedJob])

  if (!job) return null

  return (
    <Slide direction='left' in={!!job}>
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          minHeight: 0,
          borderLeft: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        <Box
          ref={scrollContainerRef}
          sx={{
            flex: 1,
            overflow: 'auto',
            p: 3,
            '&::-webkit-scrollbar': {
              width: '6px',
            },
            '&::-webkit-scrollbar-track': {
              backgroundColor: 'transparent',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey.400',
              borderRadius: '3px',
            },
          }}
        >
          <JobDetailContent
            job={job}
            rankedJob={rankedJob}
            conversationId={conversationId}
            onFavoriteClick={onFavoriteClick}
            onAskStethi={onAskStethi}
            isMobile={false}
          />
        </Box>
      </Box>
    </Slide>
  )
}

export default memo(JobDetailPanel)
